import { IBaseArgument } from './IBaseArgument';
import { BaseResponseBuilder } from './BaseResponseBuilder';

export class DisplayPromocodeItemResponseBuilder extends BaseResponseBuilder {
    constructor() {
        super('DisplayPromocodeItem');
    }
    public withCampaignId = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['campaignId'] = this.initField(null, args);
        return this;
    }

    public withPromotionCode = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['promotionCode'] = this.initField(null, args);
        return this;
    }

    public withDiscountedValue = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['discountedValue'] = this.initField(null, args);
        return this;
    }

    public withIsApplied = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['isApplied'] = this.initField(null, args);
        return this;
    }

    public withIsAllowPricePeek = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['isAllowPricePeek'] = this.initField(null, args);
        return this;
    }

    public withIsAutoApply = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['isAutoApply'] = this.initField(null, args);
        return this;
    }

    public withIsAssignedWallet = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['isAssignedWallet'] = this.initField(null, args);
        return this;
    }
}
